import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const SupportOptions = () => {
  const supportTypes = [
  {
    id: 1,
    title: "Lived-Experience Volunteers",
    description: "Connect with peers who have navigated similar challenges including bereavement, chronic illness, workplace stress, and life transitions.",
    image: "https://images.unsplash.com/photo-1734770294943-85ad08a5027e",
    imageAlt: "Two diverse women having supportive conversation over coffee in bright modern cafe setting with warm natural lighting",
    icon: "Users",
    features: ["Peer Support", "Shared Experience", "Non-Clinical", "Available 24/7"]
  },
  {
    id: 2,
    title: "Licensed Professionals",
    description: "Access psychologists, counselors, and therapists for clinical support with evidence-based treatment approaches.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_19e7995a9-1763294337845.png",
    imageAlt: "Professional female therapist with warm smile wearing business casual attire in modern office with plants and natural light",
    icon: "Stethoscope",
    features: ["Clinical Care", "Licensed Providers", "Telehealth", "Insurance Accepted"]
  },
  {
    id: 3,
    title: "Cultural & Language Matching",
    description: "Find helpers who understand your cultural background and speak your preferred language for more comfortable conversations.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b0744f9a-1765646427860.png",
    imageAlt: "Diverse group of five professionals from different ethnic backgrounds smiling together in modern collaborative workspace",
    icon: "Globe",
    features: ["15+ Languages", "Cultural Sensitivity", "Identity-Affirming", "LGBTQ+ Friendly"]
  }];


  return (
    <section className="bg-background py-16 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-foreground mb-4">
            Choose the Support That Fits Your Needs
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Whether you need peer support or professional care, we'll match you with the right helper in minutes
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {supportTypes?.map((option) =>
          <div
            key={option?.id}
            className="bg-card rounded-xl border border-border overflow-hidden hover:shadow-lg transition-shadow duration-200">

              <div className="relative h-48 overflow-hidden">
                <Image
                src={option?.image}
                alt={option?.imageAlt}
                className="w-full h-full object-cover" />

                <div className="absolute top-4 left-4 bg-primary/90 backdrop-blur-sm rounded-lg p-2">
                  <Icon name={option?.icon} size={24} className="text-primary-foreground" />
                </div>
              </div>

              <div className="p-6">
                <h3 className="text-xl font-semibold text-foreground mb-3">
                  {option?.title}
                </h3>
                <p className="text-muted-foreground mb-4 text-sm leading-relaxed">
                  {option?.description}
                </p>

                <div className="flex flex-wrap gap-2">
                  {option?.features?.map((feature, index) =>
                <span
                  key={index}
                  className="inline-flex items-center gap-1 px-3 py-1 bg-muted rounded-full text-xs font-medium text-foreground">

                      <Icon name="Check" size={14} className="text-success" />
                      {feature}
                    </span>
                )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default SupportOptions;